import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ProfileSummary.css";

const ProfileSummary = () => {
  AOS.init();
  return (
    <div className="profile-summary-container">
      <h1>Profile Summary</h1>
      <div
        data-aos="fade-up"
        data-aos-offset="10"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        className="profile-summary-content"
      >
        <div className="summary-card">
          <div className="summary-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FFD700"/>
            </svg>
          </div>
          <h2>Frontend Engineer</h2>
          <div className="experience-badge">5 Years Experience</div>
          <p className="summary-text">
            Frontend Engineer with <strong>5 years of experience</strong> building and optimizing scalable, 
            high-performance web applications using <strong>React, Next.js, JavaScript, TypeScript, HTML, and CSS</strong>.
          </p>
          <p className="summary-text">
            Experienced in <strong>server-side rendering (SSR)</strong>, <strong>performance optimization</strong>, 
            <strong>Core Web Vitals</strong>, and <strong>SEO improvements</strong> for large-scale consumer platforms.
          </p>
          <p className="summary-text">
            Strong collaborator with cross-functional teams, skilled in delivering clean, maintainable, and 
            production-ready UI solutions while following modern frontend best practices.
          </p>
          
          <div className="highlights-grid">
            <div className="highlight-item">
              <div className="highlight-icon">⚡</div>
              <h4>18% Faster Load</h4>
              <p>Core Web Vitals optimization</p>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon">📈</div>
              <h4>8% Higher Conversions</h4>
              <p>Through performance tuning</p>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon">🚀</div>
              <h4>Next.js Migration</h4>
              <p>SSR & RSC implementation</p>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon">🎮</div>
              <h4>Game Development</h4>
              <p>Phaser.io & Canvas expertise</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSummary;

